import { API_URL } from "helpers/constant";
import { request } from "./api";

export function getListProduct(params = {}) {
  const queryString = new URLSearchParams(params).toString();
  const url = `${API_URL}/product/products${
    queryString ? `?${queryString}` : ""
  }`;

  return request({
    url,
    method: "GET",
  });
}

export function getProductDetail(params = {}) {
  const queryString = new URLSearchParams(params).toString();
  const url = `${API_URL}/product/products${
    queryString ? `?${queryString}` : ""
  }`;

  return request({
    url,
    method: "GET",
  });
}

export function createProduct(body) {
  return request({
    url: `${API_URL}/product/products`,
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function updateProduct(body) {
  return request({
    url: `${API_URL}/product/products`,
    method: "PUT",
    body: JSON.stringify(body),
  });
}

export function uploadProductImage(body) {
  return request({
    url: `${API_URL}/product/product-image`,
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function createVariant(body) {
  return request({
    url: `${API_URL}/product/product-variant`,
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function updateProductVariant(body) {
  return request({
    url: `${API_URL}/product/product-variant`,
    method: "PUT",
    body: JSON.stringify(body),
  });
}

export function deleteProduct(id) {
  return request({
    url: `${API_URL}/product/products?id=${id}`,
    method: "DELETE",
  });
}

export function deleteProductVariant(id) {
  return request({
    url: `${API_URL}/product/product-variant?id=${id}`,
    method: "DELETE",
  });
}

export function deleteProductImage(id) {
  return request({
    url: `${API_URL}/product/product-image?id=${id}`,
    method: "DELETE",
  });
}

export function getProductToSync() {
  const url = `${API_URL}/product/list-sync`;
  return request({
    url,
    method: "GET",
  });
}

export function getProductTags() {
  const url = `${API_URL}/product/product-tags`;
  return request({
    url,
    method: "GET",
  });
}

export function getProductCategories() {
  const url = `${API_URL}/product/product-categories`;
  return request({
    url,
    method: "GET",
  });
}

export function getProductBrands() {
  const url = `${API_URL}/product/product-brand`;
  return request({
    url,
    method: "GET",
  });
}
